import _default from './Embed';
export { _default as default };